import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import OrderReturnListContainer from '../../containers/order/OrderReturnListContainer';
import { ORDER_PAGE_NAME } from '../../constants/service/app/orderConstants';

const OrderReturnList = () => {
  return (
    <PageTemplate pageName={ORDER_PAGE_NAME.ORDER_RETURN_LIST}>
      <OrderReturnListContainer pageName={ORDER_PAGE_NAME.ORDER_RETURN_LIST} />
    </PageTemplate>
  );
};

export default OrderReturnList;
